module.exports = __webpack_public_path__ + "static/PMB_octopus-4c9e4571e24e26d809e5b8d1073257f6.png";